<mat-button-toggle-group
  class="app-sign-field-type-selector"
  [value]="value"
  (change)="onSelect($event)"
>
  <mat-button-toggle
    *ngFor="let option of options"
    [value]="option.value"
    [matTooltip]="option.textI18n | translate"
    matTooltipPosition="above"
  >
    <lib-icon
      *ngIf="option.icon"
      [icon]="option.icon"
      [color]="option.value === value ? 'accent' : null"
    ></lib-icon>
  </mat-button-toggle>
</mat-button-toggle-group>
